import { render, staticRenderFns } from "./customIcon.vue?vue&type=template&id=c6e16c9a&scoped=true"
import script from "./customIcon.vue?vue&type=script&lang=js"
export * from "./customIcon.vue?vue&type=script&lang=js"
import style0 from "./customIcon.vue?vue&type=style&index=0&id=c6e16c9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e16c9a",
  null
  
)

export default component.exports